import { Link } from "react-router-dom";
import Logo from "../graphics/tk-logo.png";
import "../style/header.css";

const Header = () => {
  return (
    <header className="topnav">
        <div>
            <Link className = "topnav-a" to = "/">Home</Link>
            <Link className = "topnav-a" to = "addProduct">Add Product</Link>
            <Link className = "topnav-a" to = "listProducts">List Products</Link>
        </div>
        {/* <div className="logo"> */}
            <a href="https://tkwebdev.ca" target="_blank" rel="noopener noreferrer" >
                <img 
                    src         = { Logo } 
                    alt         = "TK's logo" 
                    title       = "Home" 
                    width       = "100%"
                    className   = "logo"
                />
            </a>
        {/* </div> */}
    </header>
  );
};

export default Header;